<ng-container *transloco="let t">
@if (application) {
  <div class="container p-xs-0 mobile-loan-details-container" [class.mobile-messages-active]="mobileActiveTab === 'messages'">
    <div class="row my-3" [class.mobile-hide-header]="mobileActiveTab === 'messages'">
      <div class="col-md-12 d-flex align-items-stretch d-revert">
        <loan-info [isAgent]="isAgent" [isDetailView]="true" [showViewTasksButton]="false"
          [showBorrowerContactDetails]="true" [portalContent]="portalContent" [application]="application"
          [otherBorrowersOnLoan]="otherBorrowersOnLoan"
          [mobileInfoExpandedDefault]="mobileActiveTab === 'actions'"></loan-info>
      </div>
    </div>
    <div class="row my-3 mobile-content-row align-items-start">
      <!-- On mobile: content sections are toggled via tab buttons; on desktop: normal 2-column layout -->
      <div class="col-md-9 mobile-order-tasks" [class.mobile-tab-hidden]="mobileActiveTab !== 'tasks'">
        @if (portalContent?.isBulkUploadEnabled) {
          <div class="d-none d-md-block">
            <bulk-upload
              [applicationId]="loanId"
              [isAgent]="isAgent"
              (confirmed)="onBulkUploadConfirmed()">
            </bulk-upload>
          </div>
        }
        <portal-task-information #tasksView [appId]="loanId" [isAgent]="isAgent"
          [doNotEnforceChronologicalOrderInEsignTasks]="!!portalContent?.doNotEnforceChronologicalOrderInEsignTasks"
          (tasksLoaded)="onTasksLoaded($event)">
        </portal-task-information>
      </div>
      <div class="col-md-9 mobile-tab-section d-none d-mobile-block" [class.mobile-tab-hidden]="mobileActiveTab !== 'upload'">
        @if (portalContent?.isBulkUploadEnabled) {
          <bulk-upload
            [applicationId]="loanId"
            [isAgent]="isAgent"
            (confirmed)="onBulkUploadConfirmed()">
          </bulk-upload>
        }
      </div>
      <div class="col-md-3 mobile-order-sidebar">
        <div class="row mb-2 mobile-order-actions" [class.mobile-tab-hidden]="mobileActiveTab !== 'actions'">
          @if (actionsApplicableToLoan && shouldShowLoanActions) {
            <loan-actions
              [application]="application"
              [otherBorrowersOnLoan]="otherBorrowersOnLoan"
              [isAgent]="isAgent"
              [actionsApplicable]="actionsApplicableToLoan"
              [paymentLinkConfig]="paymentLinkConfig"
              (openAssetVerificationClicked)="onOpenAssetVerificationClicked()"
              (openIncomeVerificationClicked)="onOpenIncomeVerificationClicked()"
              (additionalDocumentsAddedToLoan)="onAdditionalDocumentsAddedToLoan()">
            </loan-actions>
          } @else {
            <div class="mobile-empty-state d-none">
              <i class="fas fa-bolt mobile-empty-icon"></i>
              <p class="mobile-empty-text">{{ t('portal.loanDetails.noLoanActionsAvailable') }}</p>
            </div>
          }
        </div>
        <div class="row mb-2" [class.mobile-tab-hidden]="mobileActiveTab !== 'messages'">
          <loan-messages [loanId]="loanId" [borrowerName]="application?.myDetails?.borrowerName"></loan-messages>
        </div>
        <div class="row mobile-loan-contacts-section" [class.mobile-tab-hidden]="mobileActiveTab !== 'team'">
          @if (borrowerContact) {
            <loan-contacts [borrowerContact]="borrowerContact" [mobileCollapsible]="false"></loan-contacts>
          } @else {
            <div class="mobile-empty-state d-none">
              <i class="fas fa-users mobile-empty-icon"></i>
              <p class="mobile-empty-text">{{ t('portal.loanDetails.noLoanTeamMembers') }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile sticky bottom tab bar -->
  <div class="mobile-sticky-actions d-none">
    <button class="mobile-action-btn" [class.active]="mobileActiveTab === 'actions'" (click)="onMobileNavClicked('actions')">
      <span class="mobile-tab-icon"><i class="fas fa-bolt"></i></span>
      <span class="mobile-tab-label">{{ t('portal.loanDetails.actions') }}</span>
    </button>
    <button class="mobile-action-btn" [class.active]="mobileActiveTab === 'tasks'" (click)="onMobileNavClicked('tasks')">
      <span class="mobile-tab-icon">
        <i class="fas fa-tasks"></i>
        @if (outstandingTaskCount > 0) {
          <span class="mobile-tab-badge">{{ outstandingTaskCount > 99 ? '99+' : outstandingTaskCount }}</span>
        }
      </span>
      <span class="mobile-tab-label">{{ t('portal.loanDetails.tasks') }}</span>
    </button>
    @if (portalContent?.isBulkUploadEnabled) {
      <button class="mobile-action-btn" [class.active]="mobileActiveTab === 'upload'" (click)="onMobileNavClicked('upload')">
        <span class="mobile-tab-icon"><i class="fas fa-paperclip"></i></span>
        <span class="mobile-tab-label">{{ t('portal.loanDetails.upload') }}</span>
      </button>
    }
    <button class="mobile-action-btn" [class.active]="mobileActiveTab === 'messages'" (click)="onMobileNavClicked('messages')">
      <span class="mobile-tab-icon"><i class="fas fa-comment-alt"></i></span>
      <span class="mobile-tab-label">{{ t('portal.loanDetails.messages') }}</span>
    </button>
    <button class="mobile-action-btn" [class.active]="mobileActiveTab === 'team'" (click)="onMobileNavClicked('team')">
      <span class="mobile-tab-icon"><i class="fas fa-users"></i></span>
      <span class="mobile-tab-label">{{ t('portal.loanDetails.loanTeam') }}</span>
    </button>
  </div>
}
</ng-container>
